{
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.cta-button": [
    {
      "type": 0,
      "value": "View your plan"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.header-title": [
    {
      "type": 0,
      "value": "Your plan is waiting for you!"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.intro-paragraph-1": [
    {
      "type": 0,
      "value": "Getting started is the hardest step, and you've already done that! Your plan "
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " is waiting for you to unlock its full potential!"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.intro-paragraph-2": [
    {
      "type": 0,
      "value": "Whether you're managing a product launch or tracking bugs, Jira Plans offers powerful planning tools to help your and your team stay organized, track progress, and keep everyone aligned. It can help you:"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture-description": [
    {
      "type": 0,
      "value": "View work from all your teams teams, spaces, and releases in one easy-to-read Timeline view. "
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture-link": [
    {
      "type": 0,
      "value": "Open the Timeline view."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture-title": [
    {
      "type": 0,
      "value": "See the big picture"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.take-it-day-by-day-description": [
    {
      "type": 0,
      "value": "Share important dates from your plan with stakeholders using the Calendar view."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.take-it-day-by-day-link": [
    {
      "type": 0,
      "value": "Open the Calendar view."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.take-it-day-by-day-title": [
    {
      "type": 0,
      "value": "Take it day-by-day"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.transparency-for-all-description": [
    {
      "type": 0,
      "value": "Track work that's blocked by other work using the Dependencies view, and resolve conflicts before they become problems."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.transparency-for-all-link": [
    {
      "type": 0,
      "value": "Open the Dependencies view."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.transparency-for-all-title": [
    {
      "type": 0,
      "value": "Transparency for all"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-your-progress-description": [
    {
      "type": 0,
      "value": "Keep your finger on the pulse with the Summary view to avoid surprises and keep delivery on track."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-your-progress-link": [
    {
      "type": 0,
      "value": "Open your Summary view."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-your-progress-title": [
    {
      "type": 0,
      "value": "Visualize your progress"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.contact-us": [
    {
      "type": 0,
      "value": "Contact Us"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "currentYear"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. We are located at 341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.join-atlassian-community": [
    {
      "type": 0,
      "value": "Join Atlassian Community"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.unsubscribe": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.message-template.email.subject": [
    {
      "type": 0,
      "value": "Plan and track complex work confidently in "
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " in a few easy steps"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.cta-button": [
    {
      "type": 0,
      "value": "View your plan"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.header-title": [
    {
      "type": 0,
      "value": "Your plan is waiting for you!"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.intro-paragraph-1": [
    {
      "type": 0,
      "value": "Getting started is the hardest step, and you've already done that! Your plan "
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " is waiting for you to unlock its full potential!"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.intro-paragraph-2": [
    {
      "type": 0,
      "value": "Whether you're managing a product launch or tracking bugs, Jira Plans offers powerful planning tools to help your and your team stay organized, track progress, and keep everyone aligned. It can help you:"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture-description": [
    {
      "type": 0,
      "value": "View work from all your teams teams, spaces, and releases in one easy-to-read Timeline view. "
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture-read-more": [
    {
      "type": 0,
      "value": "Read more."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture-title": [
    {
      "type": 0,
      "value": "See the big picture"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.spread-the-load-description": [
    {
      "type": 0,
      "value": "Balance the workload among your teams to create an achievable yet realistic delivery plan. "
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.spread-the-load-read-more": [
    {
      "type": 0,
      "value": "Read more."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.spread-the-load-title": [
    {
      "type": 0,
      "value": "Spread the load"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.transparency-for-all-description": [
    {
      "type": 0,
      "value": "Track work that's blocked by other work using the Dependencies view, and resolve conflicts before they become problems. "
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.transparency-for-all-read-more": [
    {
      "type": 0,
      "value": "Read more."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.transparency-for-all-title": [
    {
      "type": 0,
      "value": "Transparency for all"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-your-progress-description": [
    {
      "type": 0,
      "value": "Keep your finger on the pulse with the Summary view to avoid surprises and keep delivery on track. "
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-your-progress-read-more": [
    {
      "type": 0,
      "value": "Read more."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-your-progress-title": [
    {
      "type": 0,
      "value": "Visualize your progress"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.contact-us": [
    {
      "type": 0,
      "value": "Contact Us"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "currentYear"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. We are located at 341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.join-atlassian-community": [
    {
      "type": 0,
      "value": "Join Atlassian Community"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.unsubscribe": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.message-template.email.subject": [
    {
      "type": 0,
      "value": "Plan and track complex work confidently in "
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " in a few easy steps"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.cta-button": [
    {
      "type": 0,
      "value": "View your plan"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.header-title": [
    {
      "type": 0,
      "value": "Your plan is waiting for you!"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.intro-paragraph-1": [
    {
      "type": 0,
      "value": "Getting started is the hardest step, and you've already done that! Your plan "
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " is waiting for you to unlock its full potential!"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.intro-paragraph-2": [
    {
      "type": 0,
      "value": "Whether you're managing a product launch or tracking bugs, Jira Plans offers powerful planning tools to help your and your team stay organized, track progress, and keep everyone aligned. It can help you:"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.see-big-picture-description": [
    {
      "type": 0,
      "value": "View work from all your teams teams, spaces, and releases in one easy-to-read Timeline view."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.see-big-picture-title": [
    {
      "type": 0,
      "value": "See the big picture"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.stay-realistic-description": [
    {
      "type": 0,
      "value": "Balance the workload among your teams to create an achievable yet realistic delivery plan."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.stay-realistic-title": [
    {
      "type": 0,
      "value": "Spread the load"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.take-it-day-by-day-description": [
    {
      "type": 0,
      "value": "Share important dates from your plan with stakeholders using the Calendar view."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.take-it-day-by-day-title": [
    {
      "type": 0,
      "value": "Take it day-by-day"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.transparency-for-all-description": [
    {
      "type": 0,
      "value": "Track work that's blocked by other work using the Dependencies view, and resolve conflicts before they become problems."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.transparency-for-all-title": [
    {
      "type": 0,
      "value": "Transparency for all"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.visualize-your-progress-description": [
    {
      "type": 0,
      "value": "Keep your finger on the pulse with the Summary view to avoid surprises and keep delivery on track."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.visualize-your-progress-title": [
    {
      "type": 0,
      "value": "Visualize your progress"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.contact-us": [
    {
      "type": 0,
      "value": "Contact Us"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "currentYear"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. We are located at 341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.join-atlassian-community": [
    {
      "type": 0,
      "value": "Join Atlassian Community"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.unsubscribe": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.message-template.email.subject": [
    {
      "type": 0,
      "value": "Plan and track complex work confidently in "
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " in a few easy steps"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.avatar.no-translate": [
    {
      "type": 0,
      "value": "avatar"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.blueprint.no-translate": [
    {
      "type": 0,
      "value": "blueprintLogo"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.collborate.message": [
    {
      "type": 0,
      "value": "Collaborate, align, and deliver work, all in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " one place "
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.collect.message": [
    {
      "type": 0,
      "value": "Collect and send work to other teams or stakeholders using "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " forms "
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.globe.no-translate": [
    {
      "type": 0,
      "value": "globeLogo"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.invited-message": [
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": "  invited you to "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " "
        },
        {
          "type": 1,
          "value": "planTitle"
        },
        {
          "type": 0,
          "value": " "
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.join.link": [
    {
      "type": 0,
      "value": "Join the Plan"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.learn.more.message": [
    {
      "type": 0,
      "value": "Learn more about Jira"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.logo.no-translate": [
    {
      "type": 0,
      "value": "logo"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.contactus.template": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.copyright.template": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.location.template": [
    {
      "type": 0,
      "value": "We are located at 341 George Street, Sydney, NSW, 2000, Australia."
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template.dot": [
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.use.jira.generic.message": [
    {
      "type": 0,
      "value": "Use Jira to..."
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.view.work.message": [
    {
      "type": 0,
      "value": "View work your way using the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " list, board, calendar "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " timeline "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " views"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.write.no-translate": [
    {
      "type": 0,
      "value": "writeLogo"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": ") invited you to ("
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "jira-plan-created-reminder-experiment.action": [
    {
      "type": 0,
      "value": "View plan"
    }
  ],
  "jira-plan-created-reminder-experiment.body": [
    {
      "type": 0,
      "value": "View your plan from end-to-end and get insights to help you move forward. Your plan can do it all!"
    }
  ],
  "jira-plan-created-reminder-experiment.title": [
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " is waiting for you in Jira"
    }
  ],
  "jira-plans-efa-change-boarding.message-templates.flag.description": [
    {
      "type": 0,
      "value": "Fields that aren’t part of a space’s configuration can no longer be used in your plan. Add those fields to your space to use them again."
    }
  ],
  "jira-plans-efa-change-boarding.message-templates.flag.goToSettings": [
    {
      "type": 0,
      "value": "Go to settings"
    }
  ],
  "jira-plans-efa-change-boarding.message-templates.flag.read-more": [
    {
      "type": 0,
      "value": "Read more"
    }
  ],
  "jira-plans-efa-change-boarding.message-templates.flag.title": [
    {
      "type": 0,
      "value": "Some fields in your plan may be deactivated."
    }
  ]
}